module.exports = __webpack_public_path__ + "static/wlc-image-sales-page-monthly-live-events.b999fe8d.jpg";